// motion.js

export const flowIn = {
  initial: {opacity: 0, x: 50, rotate: 5},
  animate: {opacity: 1, x: 0, rotate: 0},
  exit: {opacity: 0, x: -50, rotate: -5},
  transition: {duration: 0.5, ease: "easeOut"},
};

export const bounceAir = {
  initial: {y: -30, opacity: 0},
  animate: {y: 0, opacity: 1},
  exit: {y: -30, opacity: 0},
  transition: {type: "spring", stiffness: 120, damping: 5},
};

export const fadeOutShrink = {
  exit: {opacity: 0, scale: 0.7},
  transition: {duration: 0.3, ease: "easeInOut"},
};

export const rotateBounce = {
  initial: {rotate: -15, opacity: 0, scale: 0.8},
  animate: {rotate: 0, opacity: 1, scale: 1},
  exit: {rotate: 15, opacity: 0, scale: 0.8},
  transition: {type: "spring", stiffness: 100, damping: 8},
};

export const customMotion = {
  initial: {opacity: 0, scale: 0.9, y: 20},
  animate: {opacity: 1, scale: 1, y: 0},
  exit: {opacity: 0, scale: 0.7, y: -20},
  transition: {duration: 0.4, ease: "easeInOut"},
};

// motion.js

/** 🟢 FORM & CONTAINER ANIMATIONS */
export const fadeSlideIn = {
  initial: {opacity: 0, x: 50},
  animate: {opacity: 1, x: 0},
  exit: {opacity: 0, x: -50},
  transition: {duration: 0.3, ease: "easeInOut"},
};

export const popupEffect = {
  initial: {scale: 0.8, opacity: 0},
  animate: {scale: 1, opacity: 1},
  exit: {scale: 0.8, opacity: 0},
  transition: {duration: 0.3, ease: "easeOut"},
};

export const springEffect = {
  initial: {scale: 0.5, opacity: 0},
  animate: {scale: 1, opacity: 1},
  exit: {scale: 0.8, opacity: 0},
  transition: {type: "spring", stiffness: 120, damping: 10},
};

/** 🔵 GRID ANIMATIONS */
export const gridStagger = {
  hidden: {opacity: 0, y: 20},
  show: {
    opacity: 1,
    y: 0,
    transition: {staggerChildren: 0.1, ease: "easeOut", duration: 0.6},
  },
};

export const gridItem = {
  hidden: {opacity: 0, scale: 0.9},
  show: {opacity: 1, scale: 1, transition: {duration: 0.3}},
};

/** 🔴 LIST ANIMATIONS */
export const listContainer = {
  hidden: {opacity: 0},
  show: {
    opacity: 1,
    transition: {staggerChildren: 0.2, delayChildren: 0.2},
  },
};

export const listItem = {
  hidden: {opacity: 0, x: -20},
  show: {opacity: 1, x: 0, transition: {duration: 0.3, ease: "easeOut"}},
  exit: {opacity: 0, x: -20, transition: {duration: 0.3, ease: "easeIn"}},
};

/** 🟡 BANNER ANIMATION */
export const bannerEffect = {
  initial: {opacity: 0, y: -50},
  animate: {opacity: 1, y: 0, transition: {duration: 0.5, ease: "easeOut"}},
  exit: {opacity: 0, y: -50, transition: {duration: 0.3, ease: "easeIn"}},
};

/** 🟣 MODAL ANIMATION */
export const modalEffect = {
  initial: {opacity: 0, scale: 0.8},
  animate: {opacity: 1, scale: 1, transition: {duration: 0.3, ease: "easeOut"}},
  exit: {opacity: 0, scale: 0.8, transition: {duration: 0.3, ease: "easeIn"}},
};

/** 🔷 PAGE TRANSITION EFFECT */
export const pageTransition = {
  initial: {opacity: 0, y: 20},
  animate: {opacity: 1, y: 0, transition: {duration: 0.4, ease: "easeOut"}},
  exit: {opacity: 0, y: -20, transition: {duration: 0.3, ease: "easeIn"}},
};

/** 🔶 POPUP EFFECT */
export const popupFloat = {
  initial: {opacity: 0, y: 20, scale: 0.95},
  animate: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {duration: 0.3, ease: "easeOut"},
  },
  exit: {
    opacity: 0,
    y: 20,
    scale: 0.95,
    transition: {duration: 0.3, ease: "easeIn"},
  },
};
